import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const ERROR_MESSAGES = {
  not_invited:   'Your account has not been set up yet. Please contact an administrator.',
  no_email:      'Microsoft did not share your email address. Please contact an administrator.',
  invalid_state: 'Login session expired. Please try again.',
  sso_failed:    'Microsoft sign-in failed. Please try again or use your username and password.',
};

export default function SsoCallbackPage({ onToken }) {
  const [searchParams] = useSearchParams();
  const [step, setStep]   = useState('Checking token…');
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const err   = searchParams.get('error');

    if (!token) {
      setError(ERROR_MESSAGES[err] || `No token received (error param: ${err || 'none'})`);
      return;
    }

    const parts = token.split('.');
    if (parts.length !== 3) {
      setError(`Bad token format: got ${parts.length} part(s), expected 3`);
      return;
    }

    setStep('Token received — decoding…');

    let payload;
    try {
      const b64    = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const padded = b64 + '=='.slice(0, (4 - b64.length % 4) % 4);
      payload = JSON.parse(atob(padded));
    } catch (e) {
      setError(`JWT decode failed: ${e.message}`);
      return;
    }

    setStep(`Decoded OK (user: ${payload.username || payload.id}) — signing in…`);

    try {
      onToken(token);
      setStep('Auth state updated — redirecting…');
    } catch (e) {
      setError(`loginWithToken failed: ${e.message}`);
    }
  }, [searchParams, onToken]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center p-4">
        <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-white/10 p-8 w-full max-w-md text-center">
          <p className="text-red-300 mb-2 font-semibold">Sign-in failed</p>
          <p className="text-red-400 text-sm mb-6 font-mono break-all">{error}</p>
          <a href="/" className="text-indigo-400 hover:text-indigo-300 text-sm transition-colors">
            Back to login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
      <p className="text-white text-lg">{step}</p>
    </div>
  );
}
